import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { recognitionPrograms } from "@/mocks/homeData";

export default function RecognitionSection() {
  return (
    <section className="bg-tie-grey-light py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Header */}
        <ScrollReveal>
          <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
              <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                / Readiness & Recognition
              </span>
            </div>
            <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary">
              Measure. Score. Recognize.
            </h2>
            <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
              Evidence-based readiness scoring and rigorous recognition that
              validates real innovation impact.
            </p>
          </div>
        </ScrollReveal>

        {/* Recognition Cards */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          {recognitionPrograms.map((prog, index) => (
            <ScrollReveal key={prog.name} delay={index * 150}>
              <div className="bg-white rounded-2xl p-6 md:p-8 border border-tie-grey-dark hover:shadow-lg transition-all duration-300">
                {/* Header */}
                <div className="flex items-start gap-4 mb-5 md:mb-6">
                  <div className="w-12 h-12 rounded-xl bg-tie-teal/10 flex items-center justify-center shrink-0">
                    <i
                      className={`${
                        index === 0
                          ? "ri-bar-chart-box-line"
                          : "ri-trophy-line"
                      } text-tie-teal text-xl`}
                    />
                  </div>
                  <div>
                    <span className="text-xs font-bold text-tie-teal uppercase tracking-wider">
                      {prog.name}
                    </span>
                    <h3 className="text-lg md:text-xl font-bold text-tie-text-primary mt-1">
                      {prog.fullName}
                    </h3>
                  </div>
                </div>

                <p className="text-sm md:text-base text-tie-text-secondary leading-relaxed mb-5 md:mb-6">
                  {prog.description}
                </p>

                {/* Metrics */}
                <div className="grid grid-cols-2 gap-3 md:gap-4">
                  {prog.metrics.map((metric) => (
                    <div
                      key={metric.label}
                      className="p-3 md:p-4 rounded-lg bg-tie-grey-light border border-tie-grey-dark text-center"
                    >
                      <div className="font-serif text-xl md:text-2xl font-bold text-tie-navy">
                        {metric.value}
                      </div>
                      <div className="text-xs text-tie-text-muted mt-1">
                        {metric.label}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}